<template lang="pug">
    .map-box(v-if="token")
        MglMap(
            :access-token="token"
            :map-style="style"
            :center="center"
            :bearing="bearing"
            :zoom="zoom"
            :max-zoom="18"
            :min-zoom="3"
            :pitch="40"
            @load="loaded"
        )
            MglMarker(v-for="store in stores" :key="store.key" :coordinates="store.coordinates")
                a.logo-marker(slot="marker" @click="resolve(store.key)") RH
</template>

<script>

import _ from 'lodash'

import mapboxgl from 'mapbox-gl'
import MultiTouch from 'mapbox-gl-multitouch'
import { MglMap, MglMarker } from 'vue-mapbox'

import { mapGetters } from 'vuex'

import router from '@/router';

export default {
    name: 'MapBox',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        MglMap,
        MglMarker,
    },
    computed: {
        style() {
            let style = 'mapbox://styles/mapbox/light-v10'
            if (this.mode === 'dark') style = 'mapbox://styles/mapbox/dark-v10'
            return style
        },
        stores() {
            return [
                { key: 'berlin', coordinates: [13.397220, 52.513820] }, // Berlin
                { key: 'duesseldorf', coordinates: [6.774320, 51.222330] }, // Düsseldorf
                { key: 'munich', coordinates: [11.579410, 48.158010] }, // Münchecn
                { key: 'cologne', coordinates: [6.936050, 50.942090] }, // Köln
                { key: 'paris', coordinates: [2.328850, 48.851200] }, // Paris
                //{ key: 'gothenburg', coordinates: [11.975291, 57.699059] }, // Götheborg
                { key: 'bern', coordinates: [7.452576, 46.948039] }, // Bern
                { key: 'antwerp', coordinates: [4.402596, 51.215716] }, // Antwerpen
            ]
        },
        center() {
            return [5.381836, 55.160455]
        },
        zoom() {
            return 4
        },
        bearing() {
            return -40
        },
        ...mapGetters({
            mode: 'currentPage/mode',
            token: 'mapBoxToken',
        }),
    },
    methods: {
        resolve(key) {
            const resolved = this.$router.resolve(key)
            const name = _.get(resolved, 'route.name')
            if (name && name !== 'Page Not Found') {
                router.push(key)
            }
        },
        async loaded(event) {

            let bounds = new mapboxgl.LngLatBounds()
            this.stores.forEach(store => bounds.extend(store.coordinates))

            let map = event.map
            map.fitBounds(bounds, {
                padding: 40,
                bearing: 0,
                pitch: 0,
                maxZoom: 18,
                duration: 10000,
            }, {
                breakonfitbounds: true,
            })

            let timeout, reset = false
            map.on('moveend', event => {
                if (timeout) clearTimeout(timeout)
                if (event.breakonfitbounds || reset) {
                    reset = true
                    timeout = setTimeout(() => {
                        map.easeTo({ pitch: 0, bearing: 0 })
                        reset = false
                    }, 100)
                }
            })
            map.on('move', () => {
                if (timeout) clearTimeout(timeout)
            })

            // map.dragPan.disable();
            // map.scrollZoom.disable();

            // map.on('touchstart', event => {
            //     const e = event.originalEvent;
            //     if (e && 'touches' in e) {
            //         if (e.touches.length > 1) {
            //             map.dragPan.enable();
            //         } else {
            //             map.dragPan.disable();
            //         }
            //     }
            // });

            map.addControl(new MultiTouch());

            // Here we cathing 'load' map event
            // const asyncActions = event.component.actions

            // const newParams = await asyncActions.flyTo({
            //     center: [30, 30],
            //     zoom: 9,
            //     speed: 1
            // })
            // console.log(newParams)
        }
    },
}

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';
    @import "~bulma/sass/utilities/mixins";

    #app
        .logo-marker.mapboxgl-marker
            background: $black
            padding: 0 2px
            font-weight: bold
            // font-size: 1rem
            font-size: 14px
            color: $white
            font-family: $font
            letter-spacing: 0px
            min-width: 22px
            min-height: 22px
            line-height: 22px
            text-align: center
            border-radius: 20px
</style>
